/** Address autocomplete field using Google Places **/

const options = {
  componentRestrictions: { country: 'us' },
  fields: ['address_components', 'geometry', 'utc_offset_minutes'],
  types: ['address'],
};

const setValue = (parentForm, attr, value) => {
  // set a value if a field is present in the parent form (normally hidden)
  // matching our naming convention
  // - street
  // - city
  // - state
  // - country
  // - postal-code
  // - lat
  // - lon
  const fieldEl = parentForm.querySelector(`[name="${attr}"]`);
  if (fieldEl) {
    fieldEl.value = value;
  }
};

// observer hack to override google places from setting autocomplete=off,
// which the chrome autofill ignores and overlays over the places choices
const observer = new MutationObserver(function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.attributeName == 'autocomplete' && mutation.target.getAttribute('autocomplete') == 'off') {
      observer.disconnect();
      mutation.target.setAttribute('autocomplete', 'new-password');
    }
  }
});

const addressAutocomplete = ({ fieldEl }) => {
  const parentForm = fieldEl.closest('form');

  observer.observe(fieldEl, { attributes: true });

  // set field as required
  fieldEl.setAttribute('required', 'required');
  if (fieldEl.value) {
    // field already has a value, assume its
    // been filled from a previous form submit
    fieldEl.setAttribute('data-autocomplete-chosen', 'true');
  }

  const ac = new window.google.maps.places.Autocomplete(
    fieldEl, options
  );

  parentForm.addEventListener('submit', (e) => {
    // blur the address field on form submit to run logic below
    // for incomplete selections
    fieldEl.blur();
  });

  fieldEl.addEventListener('input', (e) => {
    if (!e.target.value) {
      // if set to blank (via input type=search clear)
      // also reset the autocomplete-chosen state
      e.target.removeAttribute('data-autocomplete-chosen');
    }
  })
  fieldEl.addEventListener('blur', (e) => {
    if (e.target.getAttribute('data-autocomplete-chosen')) {
      // dont do anything if a choice has been picked
      return;
    }
    // but clear the value completely if they did not select a choice
    e.target.value = '';
  });
  ac.addListener('place_changed', async () => {
    const place = await ac.getPlace();
    console.log('place', place);

    if (!place.geometry.location) {
      // not place returned or selected, stop processing
      return;
    }
    // tag the field that an autocomplete choice was chosen
    fieldEl.setAttribute('data-autocomplete-chosen', 'true');

    // set latitude and longitude
    setValue(parentForm, 'lat', place.geometry.location.lat());
    setValue(parentForm, 'lon', place.geometry.location.lng());

    // setting values
    let streetNumber = '';
    let route = '';
    for (const address_component of place.address_components) {
      if (address_component.types.includes("postal_code")) {
        setValue(parentForm, 'postal-code', address_component.long_name);
      }
      if (address_component.types.includes("street_number")) {
        streetNumber = address_component.long_name;
      }
      if (address_component.types.includes("route")) {
        route = address_component.long_name;
      }

      let localitySet = false;  // status of if we have already determined the locality/street
      if (address_component.types.includes("locality")) {
        setValue(parentForm, 'city', address_component.long_name);
        localitySet = true;
      } else if (address_component.types.includes("sublocality") && !localitySet) {
        setValue(parentForm, 'city', address_component.long_name);
        localitySet = true;
      } else if (address_component.types.includes("administrative_area_level_3") && !localitySet) {
        setValue(parentForm, 'city', address_component.long_name);
      }
      if (address_component.types.includes("administrative_area_level_1")) {
        setValue(parentForm, 'state', address_component.short_name);
      }
      if (address_component.types.includes("country")) {
        setValue(parentForm, 'country', address_component.short_name);
      }
    };
    setValue(parentForm, 'street', `${streetNumber} ${route}`);
  });
}

// code should execute when not testing
if (window.sb && window.sb.test !== true) {
  // assign to window for use in other functions
  window.addressAutocomplete = addressAutocomplete;
}